import React, { useState } from 'react';
import generateHarianManasukaPDF from './pdf/harianmanasuka';
import { useGlobalContext } from "../../GlobalContext";
//import axios from 'axios';

const HarianManasuka = () => {
  const { api } = useGlobalContext();
  const hariini = new Date();
  const hariiniString = hariini.toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(hariiniString);
  const [endDate, setEndDate] = useState(hariiniString);
  const [jenis, setJenis] = useState('1');
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleJenisChange = (e) => {
    setJenis(e.target.value);
  };

  const fetchData = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return [];
    }

    setIsLoading(true);
    try {
      const response = await api.get(`/api/laporan/manasuka/${startDate}/${endDate}/${jenis}`);
      return response.data.data || [];

    } catch (error) {
      console.error("Gagal mengambil data laporan Manasuka:", error);
      if (error.response) {
        alert(`Gagal mengambil data: ${error.response.status} - ${error.response.data?.message || 'Terjadi kesalahan pada server.'}`);
      } else if (error.request) {
        alert("Gagal mengambil data: Tidak ada respons dari server. Pastikan backend berjalan.");
      } else {
        alert(`Gagal mengambil data: ${error.message}`);
      }
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const printToPDF = async () => {
    const data = await fetchData();
    if (!Array.isArray(data) || data.length === 0) {
      alert("Tidak ada data untuk dicetak pada rentang tanggal ini.");
      return;
    }
    generateHarianManasukaPDF(data, startDate, endDate, jenis);
  };

  const handleExportExcel = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return;
    }
    setIsExporting(true);
    try {
      const resp = await api.get(`/api/laporan/manasuka/excel/${startDate}/${endDate}`, {
        params: { jenis },
        responseType: "blob",
      });

      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Laporan_Manasuka_${startDate}_sampai_${endDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      alert("Excel berhasil diunduh!");
    } catch (error) {
      console.error("Export Excel error:", error);
      alert("Tidak ada data untuk dicetak pada rentang tanggal ini.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div>
      <div className="container mt-3"> {/* Mengubah mt-5 menjadi mt-3 */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card card-info">
              <div className="card-header bg-info text-white">
                <h3 className="card-title">Laporan Harian Manasuka</h3>
              </div>
              <form className="form-horizontal">
                <div className="card-body">
                  <div className="form-group row d-flex align-items-center mb-1">
                    <label htmlFor="tglmulai" className="col-sm-3 col-form-label">Tanggal</label>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control"
                        id="tglmulai"
                        name="tglmulai"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </div>
                    <div className="col-auto">
                      <span>s/d</span>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control"
                        id="tglsampai"
                        name="tglsampai"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row d-flex align-items-center mb-1">
                    <label htmlFor="jenis" className="col-sm-3 col-form-label">Jenis</label>
                    <div className="col-sm-4">
                      <select
                        className="form-control"
                        id="jenis"
                        name="jenis"
                        value={jenis}
                        onChange={handleJenisChange}
                        style={{ maxWidth: '220px' }}
                      >
                        <option value="1">Anggota</option>
                        <option value="2">Masyarakat</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-right">
                  <button type="button" className="btn btn-primary btn-sm" onClick={printToPDF} disabled={isLoading || isExporting}>
                    {isLoading ? 'Memuat Data...' : 'Cetak Laporan'}
                  </button>
                  <button type="button" className="btn btn-success btn-sm" onClick={handleExportExcel} disabled={isLoading || isExporting} style={{ marginLeft: 8 }}>
                    {isExporting ? 'Mengekspor...' : 'Export Excel'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HarianManasuka;